module.exports = __webpack_public_path__ + "static/Day-2-cabin-6d9dc43c148e783e60e395cd6dbb6e51.png";